import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const emailsWorkDialogDef = {
  type: "emails",
  dialogLabel: "MY_HR_EDIT_EMAILS_WORK",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_EMAIL_WORK",
      name: "workEmail",
      dataField: "work",
      type: "text",
      validation: Yup.string().matches(
        /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
        "MY_HR_ERROR_MESSAGE_WRONG_EMAIL_FORMAT",
      ),
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
